import { useState, useEffect, useCallback } from "react";

type View = "HOME" | "EDITOR" | "SHARE" | "SHEETS";

export function useNavigation() {
  const [view, setView] = useState(getView());

  useEffect(() => {
    history.replaceState({ view: getView() }, "");

    window.addEventListener("popstate", handlePopState);
    function handlePopState(ev: PopStateEvent) {
      setView(ev.state?.view);
    }

    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const go = useCallback(
    (nextView: View) => {
      if (view === nextView) {
        return;
      }

      const url = new URL(window.location.href);

      switch (nextView) {
        case "HOME":
          switch (view) {
            case "HOME":
              break;
            default:
              url.searchParams.delete("view");
              history.replaceState({ view: nextView }, "", url.toString());
              break;
          }
          break;
        default:
          url.searchParams.set("view", nextView);
          history.pushState({ view: nextView }, view, url.toString());
          break;
      }

      setView(nextView);
    },
    [view]
  );

  return {
    view,
    go
  };
}

function getView(): View {
  const view = new URL(window.location.href).searchParams.get("view");

  switch (view) {
    case "HOME":
    case "EDITOR":
    case "SHARE":
    case "SHEETS":
      return view;
    case null:
      return "HOME";
  }

  throw new Error(`view not implemented '${view}'`);
}
